import { useState } from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../../containers/Modal/ModalContainer";

export default function SaveSearch({
  show,
  saveSearch,
  setShow,
  title,
  cancel
}) {
  const [name, setName] = useState();
  const [errorMessage, setErroMessage] = useState();
  let { t } = useTranslation();
  function clear() {
    setName();
    setErroMessage();
    if (cancel) cancel();
    setShow(false);
  }

  function submit() {
    if (name) {
      saveSearch(name);
      clear();
    } else {
      setErroMessage("required");
    }
  }
  return (
    <ModalContainer
      closeModal={clear}
      crossmarkAction={clear}
      cancelButtonTitle={t("Close")}
      cancelButtonAction={clear}
      modalTitle={title}
      submitButtonTitle={t("Done")}
      submitButtonType="submit"
      submitButtonAction={submit}
      isOpen={show}
    >
      <div className="mb-3">
        <div className="label-wrapper">
          <label className="form-label">{t("Search Name")}</label>
          {errorMessage && <div className="error-msg">{errorMessage}</div>}
        </div>
        <input
          type="text"
          className="form-control"
          onChange={({ target }) => setName(target.value)}
          value={name || ""}
        />
      </div>
    </ModalContainer>
  );
}
